<div class="modal" [class.active]="active">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="csvPromotionsModalLabel">
                    <b>커스텀 테마 생성</b>
                </h5>
                <button type="button" class="close" (click)="close()">
                    <span aria-hidden="true">
                        &times;
                    </span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="d-flex align-items-center justify-content-between m-2">
                        <h6>CSV 양식 샘플</h6>
                        <button class="btn btn-primary" type="button" (click)="download()">샘플 다운로드</button>
                    </div>
                    <table class="table table-striped m-table">
                        <thead class="m-datatable__head thead-light">
                        <tr>
                            <th>itemId</th>
                            <th>text</th>
                            <th>link</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>무료아이템 id</td>
                            <td>보여줄 문구</td>
                            <td>이동할 링크</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <app-ctsv-uploader
                            class="app-content-body-max-width"
                            apiUrl="/api/upload/csv"
                            uploaderId="ctsv-uploader"
                            (successCsv)="successCsv($event)">
                    </app-ctsv-uploader>
                </div>
                <div class="my-2 d-flex justify-content-between">
                    <button class="btn btn-primary" [disabled]="!uploadList.length || !f.form.valid || isUploading" form="uploadForm">해당 리스트 업로드</button>
                    <a class="btn btn-outline-info m-btn m-btn--icon  m-btn--icon-only m-btn--pill m-btn--air"
                       href="javascript:;" (click)="addItem()">
                        <i class="la la-plus"></i>
                    </a>
                </div>
                <form id="uploadForm" #f="ngForm" (ngSubmit)="upload()">
                    <table class="table table-striped- table-bordered table-hover table-checkable dataTable no-footer dtr-inline">
                        <thead style="background: #ebedf2" class="m-datatable__head">
                        <tr>
                            <th style="width: 120px">
                                무료아이템 id
                            </th>
                            <th>
                                보여줄 문구
                            </th>
                            <th>
                                이동할 링크
                            </th>
                            <th>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let item of uploadList; let i = index" class="banner-area-list-row">
                            <td class="form-group has-danger">
                                <input type="text" class="form-control" [(ngModel)]="item.itemId" name="itemId{{i}}" required>
                                <div class="form-control-feedback" *ngIf="(forceChk || f.controls['itemId'+i]?.touched) && f.controls['itemId'+i]?.invalid">값을 입력해주세요</div>
                            </td>
                            <td class="form-group has-danger">
                                <input type="text" class="form-control" [(ngModel)]="item.text" name="text{{i}}" required>
                                <div class="form-control-feedback" *ngIf="(forceChk || f.controls['text'+i]?.touched) && f.controls['text'+i]?.invalid">값을 입력해주세요</div>
                            </td>
                            <td class="form-group has-danger">
                                <input type="text" class="form-control" [(ngModel)]="item.link" name="link{{i}}" required>
                                <div class="form-control-feedback" *ngIf="(forceChk || f.controls['link'+i]?.touched) && f.controls['link'+i]?.invalid">값을 입력해주세요</div>
                            </td>
                            <td class="form-group has-danger">
                                <a href="javascript:;" class="btn btn-danger m-btn m-btn--icon m-btn--icon-only mx-2"
                                   (click)="deleteItem(i)">
                                    <i class="fa fa-trash cc_pointer"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
    </div>
</div>
